export const ICON = {
    APPS_WHITE: "apps_white",
    EARTH_GREEN: "earth_green",
    EARTH_WHITE: "earth_white",
    INFO_WHITE: "info_white",
    NOTIFICATION_WHITE: "notification_white",
    CARET_DOWN_WHITE: "caret_down_white",
    USER_BLUE: "user_blue",
    RIGHT_DOUBLE_ARROW_WHITE: "right_double_arrow_white",
};
Object.freeze(ICON);

export const BUTTON_TYPE = {
    DARK: "DarkButton",
    PRIMARY: "Primary",
    SECONDARY: "Secondary",
    TRANSPARENT: "Transparent",
    WHITE: "White"
}
Object.freeze(BUTTON_TYPE);

export const TASK_LABEL = {
    CP: {
        title: "CP",
        color: "#0079bf"
    },
    FAULT: {
        title: "Fault",
        color: "#eb5a46"
    }
}
Object.freeze(TASK_LABEL);

export const STORAGE_KEY = {
    LIST_DATA: "list-data"
}
Object.freeze(STORAGE_KEY);